export const intelligencesOrdering = <T extends { id: string | number }>(
  idOrderArr: (string | number)[],
  data: T[]
): T[] => {
  const mapById = new Map<string | number, T>(data.map((item) => [item.id, item]));
  const reordered = idOrderArr?.map((id) => mapById.get(id))?.filter((item): item is T => Boolean(item));
  return reordered || [];
};
